import client from '@/utils/httpClient';
import { useMutation, useQueryClient } from 'react-query';
import { ConferenceUserAssignemtKeys } from './conferenceUserAssignment.keys';

async function deleteConferenceUserAssignment(id: string): Promise<void> {
  return client.delete<void>(`/conferenceuserassignments/${id}`).then((response) => response.data);
}

export function useDeleteConferenceUserAssignment() {
  const client = useQueryClient();

  return useMutation((id: string) => deleteConferenceUserAssignment(id), {
    onSuccess: () => {
      client.invalidateQueries(ConferenceUserAssignemtKeys.list());
    },
  });
}
